<template>
  <div>
    <dynamic-form
      ref="joinForm"
      v-if="processedJoinFormFields && processedJoinFormFields.length"
      :formFields="processedJoinFormFields"
      style="max-width: 600px; margin: 0 auto;"
      :hideSubmit="true"
    />
    <br><br>
    <dynamic-form
      ref="additionalForm"
      v-if="additionalFormFields && additionalFormFields.length"
      :formFields="additionalFormFields"
      style="max-width: 600px; margin: 0 auto;"
      :hideSubmit="true"
    />
    <br><br>
    <dynamic-form
      ref="donationForm"
      v-if="processedDonationFormFields && processedDonationFormFields.length"
      :formFields="processedDonationFormFields"
      style="max-width: 600px; margin: 0 auto;"
      :hideSubmit="true"
    />
  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm/DynamicForm';
import currencyUtils from '@/utils/currency';

export default {
  props: ["joinFormFields", "joinCodeField", "joinCode", "donationFormFields", "additionalFormFields"],
  components: {
    DynamicForm
  },
  data() {
    return {
      processedDonationFormFields: null,
    }
  },
  watch: {
    async joinCode(val) {
      this.checkJoinCode(val);
    }
  },
  computed: {
    processedJoinFormFields() {
      return (this.joinFormFields || []).map(f => {
        const override = {};
        if (this.joinCodeField && f.name === this.joinCodeField) {
          override.required = false;
          override.disabled = true;
          override.value = this.joinCode;
          this.checkJoinCode(this.joinCode);
        }
        return { ...f, ...override };
      });
    }
  },
  methods: {
    ...currencyUtils,
    async checkJoinCode(val) {
      this.processedDonationFormFields = null;

      if (this.joinCodeField && this.joinCode) {
        const joinCodeInfo = await this.$api.checkJoinCode(this.joinCode);
        if (joinCodeInfo && joinCodeInfo.donationAmount) {
          this.processedDonationFormFields = [{
            fieldType: 'static-text',
            value: `Die Anmeldung ist mit einem (bereits entrichtetem) Spendenbetrag in Höhe von ${this.formatCurrency(joinCodeInfo.donationAmount, joinCodeInfo.donationCurrency)} verbunden.`
          },
          ...this.donationFormFields];
        }
      }
    },
    getFormData() {
      const joinFormData = this.$refs.joinForm && this.$refs.joinForm.formData;
      const donationFormData = this.$refs.donationForm && this.$refs.donationForm.formData;
      const additionalFormData = this.$refs.additionalForm && this.$refs.additionalForm.formData;
      if (joinFormData && donationFormData) {
        joinFormData.donationFormData = donationFormData;
      }
      if(joinFormData && additionalFormData) {
        joinFormData.additionalFormData = additionalFormData;
      }
      return joinFormData;
    },
    async validate() {
      return (!this.$refs.joinForm || await this.$refs.joinForm.validate()) &&
             (!this.$refs.donationForm || await this.$refs.donationForm.validate()) &&
             (!this.$refs.additionalForm || await this.$refs.additionalForm.validate());
    }
  }
};
</script>

<style lang="css" scoped>
</style>
